import { find, map } from 'lodash';

const nutritionPrograms = {
  1: {
    id: 1,
    level: 0,
    gender: 'F',
    title: '1200 calories per day',
    description: 'For women wanting to lose a moderate amount of weight.',
    goal: 'I want to lose weight',
  },
  2: {
    id: 2,
    level: 1,
    gender: 'F',
    title: '1500 calories per day',
    description: 'For women wanting to maintain their weight.',
    goal: 'I want to maintain my current weight',
  },
  3: {
    id: 3,
    level: 2,
    gender: 'F',
    title: '1700 calories per day',
    description: `For pregnant women. Recipes are specifically tailored to meet
      the pregnancy food safety recommendations.`,
    goal: 'I am pregnant',
  },
  4: {
    id: 4,
    level: 3,
    gender: 'M',
    title: '1800 calories per day',
    description: 'For men wanting to lose a moderate amount of weight.',
    goal: 'I want to lose weight',
  },
  5: {
    id: 5,
    level: 4,
    gender: 'M',
    title: '2000 calories per day',
    description: `For men trying to maintain their weight OR for men with a BMI
      of 30+ wanting to lose weight.`,
    goal: 'I want to maintain my current weight',
  },
  6: {
    id: 6,
    level: 3,
    gender: 'F',
    title: '1800 calories per day',
    description: `For breastfeeding women OR for women with a BMI of 30+ wanting
      to lose weight.`,
    goal: 'I am breastfeeding',
  },
  8: {
    id: 8,
    level: 4,
    gender: 'F',
    title: '2000 calories per day',
    description: `For women undertaking a highly active exercise routine,
     wanting to maintain their weight.`,
    goal: 'Female, wanting to Maintain Weight',
  },
};

const programsFor = {
  M: {
    goals: [4, 5],
    programs: [4, 5],
  },

  F: {
    goals: [1, 2, 3, 6],
    programs: [1, 2, 3, 6, 8],
  },
};

export const programIsDisabled = (program, goal) => {
  let isDisabled = false;

  if (goal === 'I am pregnant' || goal === 'I am breastfeeding') {
    isDisabled = program.goal !== goal;
  }

  return { ...program, isDisabled };
};

export const selectNutritionProgram = params => {
  if (params.id) {
    return nutritionPrograms[params.id];
  } else {
    return find(nutritionPrograms, params);
  }
};

export const selectNutritionPrograms = (gender, goal) => {
  const goals = map(programsFor[gender].goals, key => {
    return nutritionPrograms[key];
  });

  const programs = map(programsFor[gender].programs, key => {
    return programIsDisabled(nutritionPrograms[key], goal);
  });

  return { goals, programs };
};

export const selectNutritionProgramIdForBmi = (id, bmi) => {
  if (bmi > 30) {
    switch (id) {
      // Females default to progam 6
      case 1:
        return 6;

      // Males default to progam 5
      case 4:
        return 5;
    }
  }

  return id;
};



// WEBPACK FOOTER //
// ./src/logic/nutritionPrograms.js